import type {
  AvailableCashOutQuote,
  CashOutQuote
} from '@swf/core/models/sports/types/cashoutQuotes';
import type { Bet, MyBets } from '@swf/core/models/sports/types/myBets';
import type { Entity, SportsBet } from '@swf/generated/analytics/entities';
import { sportsBet, widget } from '@swf/generated/analytics/entities';
import { widgetView } from '@swf/generated/analytics/widgetView';

const betIsTrackable = ({ isSettled, stake }: Bet) => !isSettled && stake !== undefined;
const isCashOutAvailable = (cashOutQuote: CashOutQuote): cashOutQuote is AvailableCashOutQuote =>
  cashOutQuote.quoteStatus === 'AVAILABLE';

const trackOpenBets = (myBets: MyBets): void => {
  const entities: Entity[] = myBets.bets
    .filter(betIsTrackable)
    .flatMap(({ betType, betId, currency, stake, potentialWin, placedDate }) => {
      const cashOutQuote = myBets.cashoutQuotes[betId];

      return sportsBet({
        betCurrency: currency as SportsBet['betCurrency'],
        betType,
        betId: parseFloat(betId),
        betStake: stake as SportsBet['betStake'],
        betPotentialReturn: parseFloat(potentialWin),
        betPlacedTime: new Date(placedDate).getTime(),
        betCashoutPrice: isCashOutAvailable(cashOutQuote) ? cashOutQuote.quote : undefined
      });
    });

  if (entities.length > 0) {
    widgetView({}, [
      widget({
        widgetName: 'Sports My Bets Widget',
        widgetId: 'SportsMyBetsWidget'
      }),
      ...entities
    ]);
  }
};

export { trackOpenBets };
